<div class="announcement">
  <div class="close">
    <mat-icon (click)="closeForTokenLifetime()">close</mat-icon>
  </div>
  <div class="data-wrapper">
    <img class="image" src="assets/img/rename-announcement.png" alt="..." />
  </div>
  <div class="data-wrapper">
    <h2>
      {{ '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.TITLE' | translate }}
    </h2>
    <h2>
      {{ '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.SUBTITLE' | translate }}
    </h2>
    <vi-text class="description">
      {{ '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.DESCRIPTION' | translate }}
    </vi-text>
    <div class="buttons">
      <a [href]="link" target="_blank" rel="noreferrer">
        <button mat-raised-button color="primary">
          {{ '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.MORE_INFORMATION' | translate }}
        </button>
      </a>
      <button mat-raised-button color="accent" (click)="closeAndDontShowAgain()">
        {{ '+INSTALLATIONS.INSTALLATIONS.ANNOUNCEMENT_BANNER.DONT_SHOW_AGAIN' | translate }}
      </button>
    </div>
  </div>
</div>
